import {baseBackendUrl} from "../shared/constants";

export async function CheckAdmin() {
    const token = localStorage.getItem('token');
    const response = await fetch(`${baseBackendUrl}/isadmin/checkadmin`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });
    const data = await response.json();
    return data;
}

export async function CheckMentor() {
    const token = localStorage.getItem('token');
    const response = await fetch(`${baseBackendUrl}/ismentor/checkmentor`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });
    const data = await response.json();
    return data;
}